<template>
    <div class="authorization-input_label">
        <PrimeInputText
            :aria-required="props.ariaRequired"
            ref="emailLogin" 
            v-model="modelValue"
            @focus="togglePlaceholder()"
            @blur="togglePlaceholder()" 
            :id="$attrs?.id ?? 'email_login'" 
            :placeholder="!placeholderHidden && $attrs?.placeholder ? $attrs?.placeholder : !placeholderHidden ? 'Email' : ''" 
            :class="{
                'authorization-email_input': true,
                'invalid-state-input': props.errors != null
            }"
            :pt="{
                root: {
                    autocomplete: 'off'
                }
            }"
        />              
        <label
            :class="{
                'invalid-state': props.errors
            }"
            :for="`${$attrs?.id ?? 'email_login'}`">
                <p>{{$attrs?.placeholder ?? 'Email'}}</p>
        </label>
        <div class="input-folder">
            <p class="input-support-text invalid-state" v-if="props.errors">{{ props.errors }}</p>
        </div>
    </div>
</template>
<script setup lang="ts">
    import { ref } from "vue";
    import { useFocus } from "@vueuse/core";

    let modelValue = defineModel();
    const props = defineProps({
        errors: {
            type: String,
            default: null
        },
        ariaRequired: {
            type: Boolean,
            default: false
        },
    })

    const placeholderHidden = ref(false);
    const togglePlaceholder = ()=>{placeholderHidden.value = !placeholderHidden.value};

    const emailLogin = ref(null)
    const { focused } = useFocus(emailLogin);
    const setFocus = ()=>{
        focused.value = true;
    }

    defineExpose({
        setFocus
    })
</script>